
import { Checkbox as HeadlessCheckbox } from "@headlessui/react";

import { cn } from "../lib/utils";

function Checkbox( { className, ...props } ) {
  
  return (
    
    <HeadlessCheckbox
    
      className={ cn(

        "group flex items-center justify-center size-4 sm:size-4.5 border border-input bg-grey-abalaster hover:bg-grey-mercury outline-none transition-all",

        "data-checked:bg-blue-fresh data-checked:border-blue-primary focus-visible:ring-[2px] focus-visible:border-blue-fresh focus-visible:ring-blue-fresh/50 aria-invalid:ring-red/20 aria-invalid:border-red",

        className

      ) }

      { ...props }  

    />

  )

}

function CheckboxGroup( { className, ...props } ) {

  return <div className={ cn( "flex flex-col gap-4 sm:gap-6" ) } { ...props } />

}

export { Checkbox, CheckboxGroup}
